module.exports = __webpack_public_path__ + "static/media/user-headset.9a1ca977.svg";